var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('content-header',{attrs:{"title":"Психосоматические расстройства, как реакция на психосоциальный стресс"}}),_c('article-detail-component',{attrs:{"data":_vm.detail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }